import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          404. Not Found.
        </p>
      </header>
    </div>
  );
}

export default App;
